import React from 'react';
import { Grommet } from "grommet";
import AppBar from './components/Header';
import Navigation from './components/Navigation';
import Content from './components/Content';
import FooterApp from './components/Footer';
const theme = {
  global: {
    colors: {
      brand: '#300A45'
    },
    font: {
      family: 'Montserrat',
      size: '18px',
      height: '20px',
    },
    anchor: {
      hover: {
        extend: "grey"
      }
    }
  },
};

let userName: string = "MyCurriculum";

const App = () => {
  return (
    <Grommet theme={theme}>
      <AppBar name={userName} />
      <Navigation />
      <Content />
      <FooterApp />
    </Grommet>
  );
}

export default App;
